"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleViewModel = instanceOfRoleViewModel;
exports.RoleViewModelFromJSON = RoleViewModelFromJSON;
exports.RoleViewModelFromJSONTyped = RoleViewModelFromJSONTyped;
exports.RoleViewModelToJSON = RoleViewModelToJSON;
exports.RoleViewModelToJSONTyped = RoleViewModelToJSONTyped;
/**
 * Check if a given object implements the RoleViewModel interface.
 */
function instanceOfRoleViewModel(value) {
    return true;
}
function RoleViewModelFromJSON(json) {
    return RoleViewModelFromJSONTyped(json, false);
}
function RoleViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}
function RoleViewModelToJSON(json) {
    return RoleViewModelToJSONTyped(json, false);
}
function RoleViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
    };
}
